import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const SelectorEmpresas = ({ 
  value = '',
  onChange,
  disabled = false,
  isDarkMode = false
}) => {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(false);

  // Cargar empresas al montar el componente
  useEffect(() => {
    loadEmpresas();
  }, []);

  const loadEmpresas = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem('mapasac_access_token');
      const response = await fetch('/api/empresas?limit=100', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const result = await response.json();

        // Mostrar todas las empresas (activas e inactivas)
        setEmpresas(result.data.empresas || []);
      }
    } catch (error) {
      console.error('Error cargando empresas:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const empresaId = e.target.value;
    onChange(empresaId);
  };

  const selectClass = `w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none ${
    isDarkMode 
      ? `bg-gray-700 border-gray-600 ${value ? 'text-white' : 'text-gray-400'}`
      : 'bg-white border-gray-300 text-gray-900'
  } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`;

  return (
    <div className="relative">
      <select
        value={value || ''}
        onChange={handleChange}
        disabled={disabled || loading}
        className={selectClass}
      >
        <option value="">
          {loading ? 'Cargando empresas...' : 'Seleccionar empresa'}
        </option>
        {empresas.map(empresa => (
          <option key={empresa.idsucutien} value={empresa.idsucutien}>
            {empresa.nosucursal} - {empresa.descripcio}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
    </div>
  );
};

export default SelectorEmpresas;